(function () {
  'use strict';

  function initSlider(root) {
    var handle = root.querySelector('[data-cs-handle]');
    var afterImg = root.querySelector('.cs-img-after');
    if (!handle || !afterImg || root.dataset.tpCompareInitialised === 'true') return;

    root.dataset.tpCompareInitialised = 'true';
    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      handle.style.left = percent + '%';
      handle.setAttribute('aria-valuenow', Math.round(percent));
      afterImg.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
    }

    function percentFromClientX(clientX) {
      var rect = root.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    root.addEventListener('pointerdown', function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      dragging = true;
      root.setPointerCapture?.(event.pointerId);
      setPosition(percentFromClientX(event.clientX));
    });

    root.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      setPosition(percentFromClientX(event.clientX));
    });

    function stopDragging(event) {
      if (!dragging) return;
      dragging = false;
      try { root.releasePointerCapture?.(event.pointerId); } catch (error) {}
    }

    root.addEventListener('pointerup', stopDragging);
    root.addEventListener('pointercancel', stopDragging);

    handle.addEventListener('keydown', function (event) {
      var current = parseFloat(handle.style.left) || 0;
      var step = event.shiftKey ? 10 : 2;

      if (event.key === 'ArrowLeft') {
        setPosition(current - step);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        setPosition(current + step);
        event.preventDefault();
      } else if (event.key === 'Home') {
        setPosition(0);
        event.preventDefault();
      } else if (event.key === 'End') {
        setPosition(100);
        event.preventDefault();
      }
    });
  }

  function initAll(context) {
    var scope = context || document;
    var sliders = scope.matches?.('[data-cs-slider]') ? [scope] : scope.querySelectorAll('[data-cs-slider]');
    Array.prototype.forEach.call(sliders, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
